var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-container',{staticClass:"left-bottom",staticStyle:{"margin-top":"0%"},attrs:{"title":"AI数据统计图"}},[_c('div',{staticClass:"bar",staticStyle:{"height":"100%","width":"100%"},attrs:{"id":"barpic"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }